/* ===========================================================
   JOUBERT — La maison : le mouvement.

   Regle de base : la page se lit sans ce fichier. Rien n'est
   cache au depart tant que le script n'a pas pris la main ; c'est
   lui qui pose data-anime="oui", donc un script qui ne part pas
   laisse une page entiere et visible.

   Trois mouvements, pas un de plus :
     1. les elements montent de 18 px en arrivant,
     2. les photos respirent au defilement (parallaxe courte),
     3. le defilement est lisse sur grand ecran.
   =========================================================== */

(function () {
  'use strict';

  var racine = document.querySelector('[data-jb-marque]');
  if (!racine) return;

  var sobre = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (sobre.matches) return;

  var CDN = 'https://cdnjs.cloudflare.com/ajax/libs/';

  function charge(url) {
    return new Promise(function (ok, non) {
      var s = document.createElement('script');
      s.src = url;
      s.onload = ok;
      s.onerror = non;
      document.head.appendChild(s);
    });
  }

  /* Repli sans bibliotheque : si le CDN ne repond pas, on garde au
     moins l'arrivee des elements, avec l'observateur du navigateur. */
  function repli() {
    racine.setAttribute('data-anime', 'oui');
    racine.setAttribute('data-joue', 'oui');
    var style = document.createElement('style');
    style.textContent =
      '[data-jb-marque][data-anime="oui"] .mq-monte,[data-jb-marque][data-anime="oui"] .mq-ouvre{transition:opacity .7s ease,transform .7s cubic-bezier(.22,.61,.36,1)}' +
      '[data-jb-marque][data-anime="oui"] .mq-vu{opacity:1;transform:none}';
    document.head.appendChild(style);

    var vigie = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mq-vu');
        vigie.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    racine.querySelectorAll('.mq-monte').forEach(function (el) { vigie.observe(el); });
    /* L'ouverture n'attend pas d'etre croisee : elle est deja a l'ecran. */
    racine.querySelectorAll('.mq-ouvre').forEach(function (el) { el.classList.add('mq-vu'); });
    racine.querySelectorAll('.mq-hero h1 i').forEach(function (el) { el.style.transform = 'none'; });
    var ph = racine.querySelector('.mq-hero img');
    if (ph) ph.style.transform = 'none';
  }

  Promise.all([
    charge(CDN + 'gsap/3.12.5/gsap.min.js'),
    charge(CDN + 'gsap/3.12.5/ScrollTrigger.min.js')
  ]).then(function () {
    if (!window.gsap || !window.ScrollTrigger) throw new Error('gsap absent');
    gsap.registerPlugin(ScrollTrigger);
    racine.setAttribute('data-anime', 'oui');
    racine.setAttribute('data-joue', 'oui');

    /* 0. L'ouverture. Les lignes du titre remontent de sous leur
       masque, la photo se dezoome lentement derriere, le surtitre et
       la phrase suivent. C'est la sequence de la maquette, au chiffre
       pres : 1,1 s par ligne, un dixieme de decalage, et la photo sur
       plus de deux secondes pour qu'on ne la voie pas bouger. */
    gsap.timeline({ defaults: { ease: 'power3.out' } })
      .to('.mq-hero h1 i', { y: 0, duration: 1.1, stagger: 0.1 }, 0.25)
      .to('.mq-hero img', { scale: 1, duration: 2.2, ease: 'power2.out' }, 0)
      .to('.mq-hero .mq-ouvre', { opacity: 1, y: 0, duration: 0.85 }, 0.15);

    /* 1. Les arrivees. Les elements voisins montent ensemble plutot
       qu'un par un : un decalage par groupe, pas par element, sinon
       la page donne l'impression de se charger en retard. */
    racine.querySelectorAll('.mq-monte').forEach(function (el) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* 2. La respiration des photos : l'image est plus haute que son
       cadre, elle glisse de quelques pour cent pendant la traversee.
       C'est court volontairement — au-dela, ca devient un effet. */
    racine.querySelectorAll(
      '.mq-origine__image img, .mq-dim__image img, .mq-portee img, .mq-matiere__cadre img'
    ).forEach(function (img) {
      gsap.fromTo(img,
        { scale: 1.12, yPercent: -3 },
        {
          yPercent: 3,
          ease: 'none',
          scrollTrigger: {
            trigger: img.closest('figure, span, li') || img,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.6
          }
        }
      );
    });

    /* 3. L'ouverture : la photo se retire lentement pendant qu'on
       quitte le hero, le texte part un peu plus vite. */
    var hero = racine.querySelector('.mq-hero');
    if (hero) {
      gsap.to(hero.querySelector('img'), {
        yPercent: 12,
        ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.4 }
      });
      gsap.to(hero.querySelector('.mq-hero__dit'), {
        y: -40,
        opacity: 0.25,
        ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.4 }
      });
    }

    /* 4. Le defilement lisse, sur grand ecran seulement : sur
       telephone, le defilement natif est meilleur que tout ce qu'on
       peut lui substituer. */
    if (window.matchMedia('(min-width: 1000px)').matches && window.matchMedia('(pointer: fine)').matches) {
      charge(CDN + 'lenis/1.1.13/lenis.min.js').then(function () {
        var L = window.Lenis || (window.lenis && window.lenis.Lenis);
        if (!L) return;
        var lenis = new L({ duration: 1.05, smoothWheel: true, wheelMultiplier: 0.95 });
        lenis.on('scroll', ScrollTrigger.update);
        gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
        gsap.ticker.lagSmoothing(0);
      }).catch(function () { /* le defilement natif suffit */ });
    }
  }).catch(repli);
})();
